import type { ScheduleEvent, User } from '../types'

export function isYouthVisibleEvent(event: ScheduleEvent, allUsers: User[], participantId: string) {
  if (event.createdByUserId === participantId) return true

  if (event.type === 'shift') {
    return event.assignees.some((assignee) => {
      const user = allUsers.find((candidate) => candidate.id === assignee.userId)
      return user?.role === 'support_worker'
    })
  }

  if (event.type !== 'appointment') return false

  const isForParticipant = event.assignees.some((assignee) => assignee.userId === participantId)
  if (!isForParticipant) return false

  const creator = allUsers.find((user) => user.id === event.createdByUserId)
  return creator?.role === 'allied_health'
}

export function youthVisibleEvents(events: ScheduleEvent[], allUsers: User[], participantId: string) {
  return events.filter((event) => isYouthVisibleEvent(event, allUsers, participantId))
}

